<header class="main-header d-flex justify-content-between align-items-center">
  <a class="main-header-logo" href="/dashboard" routerLink="dashboard">
    <img src="/assets/images/favicon/android-chrome-192x192.png" [style.height.px]="30" alt="Predict Mapper Logo">
    MAPPER
  </a>

  <div class="me-2">
    <button class="pm-btn" [matMenuTriggerFor]="userMenu" aria-label="User menu">
      @if (userName) {
        <span class="me-2">{{userName}}</span>
      }
      <i class="bi bi-person-circle"></i>
    </button>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item (click)="logout()">
        <span>Déconnexion</span>
      </button>
    </mat-menu>
  </div>
</header>

<header class="page-header">
  <div class="container">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <h1 class="page-header-title m-0">
        <svg class="me-2" width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M27.9031 16.9499C28.1497 17.4916 27.9106 18.1302 27.3689 18.3757L15.5232 23.7601C15.3822 23.8247 15.2303 23.857 15.0774 23.857C14.9708 23.857 14.8642 23.8409 14.7608 23.8096L0.761352 19.5021C0.192759 19.3266 -0.125998 18.7235 0.0484563 18.156C0.222911 17.5874 0.827042 17.2654 1.39456 17.4431L15.0042 21.6311L26.4773 16.4158C27.0243 16.1648 27.6586 16.4104 27.9031 16.9499ZM15.0042 17.3236L1.39456 13.1356C0.827042 12.9579 0.223988 13.2799 0.0484563 13.8485C-0.127075 14.416 0.192759 15.019 0.761352 15.1946L14.7608 19.5021C14.8642 19.5333 14.9708 19.5495 15.0774 19.5495C15.2303 19.5495 15.3822 19.5172 15.5232 19.4526L27.3689 14.0682C27.9106 13.8216 28.1497 13.184 27.9031 12.6424C27.6575 12.1029 27.0243 11.8606 26.4773 12.1082L15.0042 17.3236ZM0.00215042 9.9114C-0.0204641 9.45911 0.242295 9.04128 0.659048 8.86467L8.52136 5.5511C10.0688 4.89851 10.8054 4.08439 10.8054 1.21989C10.8054 0.889283 10.9573 0.57591 11.2179 0.37238C11.4785 0.167772 11.8177 0.095621 12.1397 0.174233L26.0735 3.60733C26.5537 3.72579 26.893 4.15762 26.893 4.65298V4.81667C26.894 8.00209 26.8951 10.1052 22.9936 11.7496C20.3821 12.8502 15.5846 15.1149 15.5372 15.1386C15.3929 15.2075 15.2346 15.242 15.0774 15.242C14.9708 15.242 14.8642 15.2258 14.7608 15.1946L0.761352 10.8871C0.328446 10.7535 0.0247649 10.3637 0.00215042 9.9114ZM4.22568 9.69925L14.9945 13.0139C16.192 12.4507 19.9072 10.7137 22.1558 9.76602C24.5367 8.76236 24.7241 7.99024 24.737 5.49726L12.9021 2.57999C12.6943 4.78975 11.8565 6.48261 9.35917 7.5358L4.22568 9.69925Z" fill="white"/>
        </svg>

        Mes cartes existantes
      </h1>
      <div [style.height.px]="80" class="d-flex align-items-center">
        <button class="pm-btn pm-btn-success" (click)="createPlan()">
          <i class="bi bi-plus"></i> CREER UNE CARTE A0
        </button>
      </div>
    </div>
  </div>
</header>
<div class="container">
  <div class="row">
      <form [formGroup]="filters"
            [style.top.px]="24"
            class="d-flex z-1 mt-4 mb-3 bg-white position-sticky p-3 rounded shadow-sm align-items-center flex-row gap-2 w-100">

        <mat-form-field appearance="outline" class="d-flex flex-fill">
          <mat-label>Rechercher</mat-label>
          <input matInput autocomplete="off" formControlName="searchTerm" name="title">
          <i class="bi bi-search me-3" matSuffix></i>
        </mat-form-field>

        <mat-button-toggle-group formControlName="typePlan">
          <mat-button-toggle value="territoire">Territoire</mat-button-toggle>
          <mat-button-toggle value="user">Utilisateur</mat-button-toggle>
          <mat-button-toggle value="all">Tous les plans</mat-button-toggle>
        </mat-button-toggle-group>

        <mat-form-field appearance="outline">
          <mat-label>Date de création</mat-label>
          <mat-date-range-input [formGroup]="filters.controls.date" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Debut">
            <input matEndDate formControlName="end" placeholder="Fin">
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>

          @if (filters.controls.date.controls.start.hasError('matStartDateInvalid')) {
            <mat-error>Date de début invalide</mat-error>
          }
          @if (filters.controls.date.controls.end.hasError('matEndDateInvalid')) {
            <mat-error>Date de fin invalide</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Type risque</mat-label>
          <mat-select formControlName="typeRisque">
            <mat-option>Tous</mat-option>
            @for (risque of listRisques; track risque.type_risque) {
              <mat-option [value]="risque.type_risque">
                {{risque.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <button class="pm-btn" (click)="clearSearch()">
          <i class="bi bi-x"></i> Réinitialiser
        </button>
      </form>

    <div class="col-12 mb-5 pt-4 overflow-y-scroll">
      <a0-list [plans]="listPlans" (updateListing)="updateListing()"></a0-list>
    </div>
  </div>
</div>
